import React from "react";
import { ValidationErrors } from "src/errors";
import { AuthFormData, AuthFormDataKey } from "src/types";
import { TextInputBox, FormLvlErrorMessage } from "src/components";
import { useNavigate } from "react-router-dom";

interface AuthSignInProps {
  formData: AuthFormData;
  validationErrors?: ValidationErrors<AuthFormDataKey>;
  formLvlErrorMessage: string;
  handleInputChange: (field: AuthFormDataKey, value: string) => void;
}

const AuthSignIn: React.FC<AuthSignInProps> = ({
  formData,
  validationErrors,
  formLvlErrorMessage,
  handleInputChange
}) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-8">
      <div className="lg:hidden text-center">
        <div className="inline-flex items-center">
          <img src="/logo.png" alt="Healf Logo" className="w-20" />
        </div>
      </div>

      <div className="text-center">
        <h2 className="text-3xl font-bold text-secondary-900 mb-2">Welcome Back</h2>
        <p className="text-secondary-600">Sign in to your account</p>
      </div>

      <div className="space-y-6">
        <div>
          <TextInputBox
            id="email"
            label="Email Address"
            placeholder="Enter your email"
            value={formData.email}
            onChange={(value: string) => handleInputChange("email", value.toLowerCase())}
            type="email"
            required
            error={validationErrors?.getErrorMessageByFormDataKey("email")}
          />
        </div>

        <div>
          <TextInputBox
            id="password"
            label="Password"
            placeholder="Enter your password"
            value={formData.password}
            onChange={(value: string) => handleInputChange("password", value)}
            type="password"
            required
            error={validationErrors?.getErrorMessageByFormDataKey("password")}
          />
        </div>

        <FormLvlErrorMessage message={formLvlErrorMessage} centred={false} />

        <div className="space-y-4">
          <button
            className="w-full bg-primary-600 hover:bg-primary-700 disabled:bg-primary-300 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            disabled={!formData.email || !formData.password || !!formLvlErrorMessage}
            type="submit"
          >
            Sign In
          </button>

          <button
            className="w-full text-primary-600 hover:text-primary-700 font-medium py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-0"
            onClick={(e) => {
              e.preventDefault();
              navigate("/#reset-password");
            }}
            type="button"
          >
            Reset Password
          </button>
        </div>

        <div className="text-center pt-4 border-t border-secondary-200">
          <p className="text-sm text-secondary-600">
            Need an account?{" "}
            <button
              className="text-primary-600 hover:text-primary-700 font-medium underline focus:outline-none"
              onClick={(e) => {
                e.preventDefault();
                navigate("/#request-account-creation");
              }}
              type="button"
            >
              Request Account Creation
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export { AuthSignIn };
